import {Link} from '@shopify/hydrogen';
import {useEffect, useRef} from 'react';
import Lottie from 'lottie-web';

const PageNotFound = ({body, title, lottie}: any) => {
  const lottieRef = useRef<any>();

  useEffect(() => {
    const anim = Lottie.loadAnimation({
      container: lottieRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: lottie?.url,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    });

    anim.play();

    return () => {
      anim.destroy();
    };
  }, []);

  return (
    <div className="relative h-[1280px] w-full px-gutter">
      {lottie && (
        <div
          ref={lottieRef}
          className="absolute left-0 top-0 h-full w-full object-cover"
        />
      )}
      <div className="relative z-50 flex flex-col gap-y-10 pt-space-l">
        <h1 className="blockH3 text-center font-bold text-orange">
          {title || 'Page not found'}
        </h1>
        <p className="richH3 text-center font-bold">
          {body || "We could't find the page you're looking for."}
        </p>
        <Link to="/collections/all" className="btn-lg relative z-20 mx-auto">
          Continue Shopping
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
